import React, { useRef, useState } from 'react';
import ProgramPopper from './ProgramPopper';
import { useLazyQuery } from "@apollo/client";
import {MMTA_PROGRAMS} from 'schemas/register';
import {Row, Col} from 'react-bootstrap';
import _isEmpty from 'lodash/isEmpty';
import FormGroup from 'components/FormGroup';

export default function Preference({index, formik, renderElement}) {

    const [showPopper, setShowPopper] = useState(false);
    // Index of active programs selectbox 
    const [activeProgram, setActiveProgram] = useState(0)
    const target = useRef(null);

    function selectProgram(item) {
      const preferences = formik.values.preferences;
      preferences[index][activeProgram] = item;
      formik.setFieldValue('preferences', preferences)
      setShowPopper(false)
    }
    
    const [getPrograms, {data: programs}] = useLazyQuery(MMTA_PROGRAMS) 

    function handleArrowClick() {
      getPrograms()
      setShowPopper(!showPopper)
    }

    function handleSecondClick() {
      setActiveProgram(1)
      getPrograms({variables: {
        selectedProgram: formik.values.preferences[index][activeProgram].id
      }})
      setShowPopper(!showPopper)
    }

    return (
        <div className="preference">
            <div> {index+1} תכנית לימודים עדיפות </div>
            <div>בחר תכנית לימודים</div>
            <div className="arrowBtn" ref={target} onClick={handleArrowClick}>left arrow</div>
            {!_isEmpty(formik.values.preferences[index]) && <Row>
              <Col>
                <FormGroup
                  config={{
                    onClick: handleArrowClick,
                    readOnly: true
                  }}
                  key={`preference${index+1}`}
                  name={`preference${index+1}`}
                  elementType="input"
                  controlId={`preference${index+1}`}
                  value={formik.values.preferences[index][0].name}
                  changed={formik.handleChange}
                />
              </Col>
              {formik.values.preferences[index][0].type === 'דו חוגי' && 
              <Col> +
              </Col>}
              {formik.values.preferences[index][0].type === 'דו חוגי' && 
              <Col>
                <FormGroup
                  config={{
                    onClick: handleSecondClick,
                    readOnly: true, 
                    placeholder: 'בחר חוג שני'}}
                  key={`preference${index+1}`}
                  name={`preference${index+1}`}
                  elementType="input"
                  controlId={`preference${index+1}`}
                  value={formik.values.preferences[index][1]?.name}
                  changed={formik.handleChange}
                />
              </Col>}
            </Row>}
            <ProgramPopper 
              index={index}
              secondProgram={activeProgram}
              target={target} 
              selectProgram={selectProgram}
              programs={programs && programs.mmtaPrograms}
              show={showPopper}
            />
        </div>
    )
}
